export const localReference = {
    salaryIsSendStatusLocalEnum: [{"label":"未发送","value":0,"key":"UNSEND"},{"label":"已发送","value":1,"key":"SENDED"}],
    salaryIsLookStatusLocalEnum: [{"label":"未查看","value":0,"key":"UNLOOK"},{"label":"已查看","value":1,"key":"LOOKED"}],
    sureStatusLocalEnum: [{"label":"未确认","value":0,"key":"UNSURE"},{"label":"已确认","value":1,"key":"SURED"}],
    isOpenStatusLocalEnum: [{"label":"权限校验有效","value":1,"key":"USED"},{"label":"权限校验无效","value":0,"key":"UNUSE"}],
  }